import React from "react";
import AddIcon from "@mui/icons-material/Add";

/**
 * Shared empty / no-results state for the training list pages (Tracks, Swipe
 * Decks, Forms) so they read consistently. Pass a type-appropriate `icon`, the
 * `plural` noun, a `blurb`, and the create `onCreate` + `createLabel`. When
 * `searching` is true (items exist but search or filters removed them all) it
 * shows a no-results message and hides the Create CTA.
 */
export function TrainingEmptyState({
  icon: Icon,
  plural,
  blurb,
  createLabel,
  onCreate,
  searching = false,
  noResultsTitle,
  noResultsBlurb,
  clearLabel = "Clear filters",
  onClear,
}) {
  return (
    <div className="max-w-md mx-auto text-center px-6 py-16 rounded-2xl border-2 border-dashed border-slate-200">
      {Icon && (
        <Icon className="mx-auto text-slate-300 mb-4" style={{ fontSize: 48 }} />
      )}
      <h3 className="text-lg font-semibold text-slate-900 mb-2">
        {searching
          ? noResultsTitle || `No ${plural} match your search`
          : `No ${plural} yet`}
      </h3>
      <p className="text-sm text-slate-500 mb-6">
        {searching
          ? noResultsBlurb || "Try adjusting your search terms."
          : blurb}
      </p>
      {searching && onClear && (
        <button
          type="button"
          onClick={onClear}
          className="inline-flex items-center justify-center rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
        >
          {clearLabel}
        </button>
      )}
      {!searching && onCreate && (
        <button
          type="button"
          onClick={onCreate}
          className="inline-flex items-center gap-2 rounded-lg bg-violet-700 hover:bg-violet-800 transition-colors text-white px-4 py-2 text-sm font-medium"
        >
          <AddIcon style={{ fontSize: 18 }} />
          {createLabel}
        </button>
      )}
    </div>
  );
}

export default TrainingEmptyState;
